export const DOCUMENT_PAGES = 'PAGES'
export enum QUERY_KEYS {
  DOCUMENT_PAGES = 'PAGES',
  DOCUMENT_PAGE = 'PAGE',
}

export default QUERY_KEYS
